import { gql } from '@apollo/client';

export const ALL_PEOPLE = gql`
  query AllPeople($input: StakeholderFilter) {
    people: getPeople(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          firstName
          lastName
          nationalID
          persalNumber
          status
          caseId
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
          }
          district {
            id
            name
          }
          districtMunicipality {
            id
            name
          }
          grades {
            id
            value
            name
          }
          phase {
            id
            name
          }
          associatedInstitutions {
            id
            startDate
            endDate
            institution {
              id
              name
              emisNumber
              trackingCode
              wardLabel
              district {
                id
                name
              }
              localMunicipality {
                localMunicipality
              }
            }
          }
          institutions {
            id
            name
            emisNumber
            trackingCode
            wardLabel
            district {
              id
              name
            }
            localMunicipality {
              localMunicipality
            }
          }
          caregiverIdentificationType
          caregiverPassport
          ageRange
          employmentStatus
          identificationType
          passport
          studyPermit
          studyPermitNumber
          reasonForLackOfRoadToHealthCard
          specialNeeds
          ovc
          receivingSocialGrant
          monthlyIncomeRange
          monthlyIncome
          incomeSourceDocument
          grantType
          reasonExited
          birthCertificateOrId
          appliedForBirthCertificateOrId
          reasonForLackOfBirthCertificateOrId
          dateOfBirth
          contactNumber
          emailAddress
          disability
          disabilityTypes {
            id
            name
          }
          gender {
            id
            name
          }
          type {
            id
            name
          }
          caregiverList {
            id
            careGiverContactNumber
            careGiverEmailAddress
            careGiverEmployer
            careGiverGender {
              id
              name
            }
            careGiverMaritalStatus
            careGiverName
            careGiverNationalId
            careGiverOccupation
            careGiverOccupationOther
            careGiverPhysicalAddress
            careGiverRelationship
            careGiverSurname
            careGiverType
            proofOfIncomeFile {
              id
            }
            roadToHealthCardFile {
              id
            }
            monthlyIncomeRange
            monthlyIncome
            incomeSourceDocument
            caregiverIdentificationType
            caregiverCitizenship {
              id
              name
            }

            caregiverPassport
            employmentStatus
            reasonExited
            childResidesWithThisCaregive
            accountPayer
          }
        }
        cursor
      }
    }
  }
`;

export const ALL_PEOPLE_ADMINPORTAL = gql`
  query AllPeopleAdminPortal($input: StakeholderFilter) {
    people: getPeopleForAdminPortal(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          firstName
          lastName
          nationalID
          persalNumber
          status
          district {
            id
            name
          }
          districtMunicipality {
            id
            name
          }
          gender {
            id
            name
          }
          grades {
            id
            value
            name
          }
          personnelPosition {
            id
            name
          }
          phase {
            id
            name
          }
          populationGroup {
            id
            name
          }
          associatedInstitutions {
            id
            startDate
            endDate
            institution {
              id
              name
            }
          }
        }
        cursor
      }
    }
  }
`;
